import React, { useState, useEffect } from 'react';

const renderInline = (text) => {
  const parts = text.split(/(\*\*[^*]+\*\*)/);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i} style={{ fontWeight: '600' }}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
};

export const renderMarkdown = (text) => {
  if (!text) return null;
  const lines = text.split('\n');
  const nodes = [];
  let listItems = [];

  const flushList = (key) => {
    if (listItems.length === 0) return;
    nodes.push(
      <ul
        key={`ul-${key}`}
        style={{ listStyleType: 'disc', paddingLeft: '1.5rem', marginBottom: '0.5rem', marginTop: '0.25rem' }}
      >
        {listItems.map((item, i) => (
          <li key={i} style={{ marginBottom: '0.2rem' }}>{renderInline(item)}</li>
        ))}
      </ul>
    );
    listItems = [];
  };

  lines.forEach((line, i) => {
    const listMatch = line.match(/^\s*[-•]\s(.+)/);
    if (listMatch) {
      listItems.push(listMatch[1]);
    } else {
      flushList(i);
      const trimmed = line.trim();
      if (trimmed) {
        nodes.push(
          <p key={`p-${i}`} style={{ marginBottom: '0.3rem' }}>
            {renderInline(trimmed)}
          </p>
        );
      }
    }
  });

  flushList('end');
  return nodes;
};

const TypewriterMarkdown = ({ text, speed = 10, startDelay = 500, uniqueId, typedNotesRef }) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    if (typedNotesRef.current.has(uniqueId)) {
      setDisplayedText(text);
      return;
    }

    setDisplayedText('');

    let currentIndex = 0;
    let interval;

    const startTyping = () => {
      interval = setInterval(() => {
        if (currentIndex < text.length) {
          const nextChar = text[currentIndex];
          if (nextChar !== undefined) {
            setDisplayedText((prev) => prev + nextChar);
          }
          currentIndex += 1;
        } else {
          clearInterval(interval);
          if (text !== 'No medical content found')
            typedNotesRef.current.add(uniqueId);
        }
      }, speed);
    };

    const delayTimeout = setTimeout(startTyping, startDelay);
    return () => {
      clearTimeout(delayTimeout);
      clearInterval(interval);
    };
  }, [uniqueId, text]);

  return <div>{renderMarkdown(displayedText)}</div>;
};

export default TypewriterMarkdown;
